// var apibaseurl = "http://" + window.location.hostname + ":5000/"; // "http://192.168.0.102:5000/"

var apibaseurl = "http://localhost:5000/";
 var apibaseurl = "https://6p1fhorahj.execute-api.ap-south-1.amazonaws.com/dev/api/user/";
 var apibaseurlrider = "https://w7rplf4xbj.execute-api.ap-south-1.amazonaws.com/dev/api/";
import Vue from 'vue'
import VueResource from 'vue-resource';


export default {
    getClient(mobile, campaignid) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.get(apibaseurl + "client/" + mobile + "/" + campaignid, { header: header });
    },
    getClientNew(mobile, processName) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.get(apibaseurl + "clientnew/" + mobile + "/" + processName, { header: header });
    },
    getMultiDel(id, processName) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.get(apibaseurl + "multidel/" + id + "/" + processName, { header: header });
    },
    saveCall(payload) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "calldetails", payload, { header: header });
    },
    login(user) {
        //alert(apibaseurl);
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "login", user, { header: header });
    },
    dashboard(user) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "dashboard/",user, { header: header });
    },
    getCallList(form) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "callList", form, { header: header });
    },
    getClient(id) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "clientDetails/" ,id, { header: header });
    },
    initiateCall(sip, mobile) {
        //return Vue.http.get("https://192.168.0.119/call.php?exten=" + sip + "&number=" + mobile);
        return Vue.http.get(apibaseurl+"clicktocall/"+sip+"/"+mobile);
    },
    getHistory(id) {
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "callHistory/" ,id , { header: header });
    },
    searchCase(form){
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurl + "searchCase", form, { header: header });
    },
    familymemberlist(form){
        
        let header = { "Access-Control-Allow-Origin": "*", "content-type": "application/json" };
        return Vue.http.post(apibaseurlrider + "user/myFamilyList", form, { header: header });
    }
}